export const SubjectableType = Object.freeze({
  SUBJECT_RESULT_METRICS: 1,
  FLASH_REWARD_USER_KPIS: 2
});

